import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Field, ErrorMessage } from "formik";
import CustomForm from "../../../../components/customcomponents/CustomForm";
import { Autocomplete } from "@react-google-maps/api";

const Step1Address = ({
    values,
    setFieldValue,
    submitted,
    errors,
    t,
    isLoaded,
    onLoad,
    onPlaceChanged,
    zones,
    cities,
    setselectedzone,
}) => {
    return (
        <div>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <CustomForm
                            color={"#222528"}
                            type="text"
                            name="country"
                            lableText={t("AddProperties.country")}
                            placeholderText={t("AddProperties.enterYourCountry")}
                            onChange={(e) => setFieldValue("country", e.target.value)}
                            value={values.country}
                        />
                        {submitted && errors.country && (
                            <ErrorMessage
                                name="country"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("AddProperties.streetAddress")}</Form.Label>
                        {isLoaded && (
                            <Autocomplete
                                onLoad={onLoad}
                                onPlaceChanged={() => onPlaceChanged(setFieldValue)}
                            >
                                <input
                                    type="text"
                                    name="street_address"
                                    className="form-control"
                                    placeholder={t("AddProperties.enterStreetAddress")}
                                    value={values.street_address}
                                    onChange={(e) => {
                                        setFieldValue("street_address", e.target.value);
                                    }}
                                />
                            </Autocomplete>
                        )}
                        {submitted && errors.street_address && (
                            <ErrorMessage
                                name="street_address"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <CustomForm
                        color={"#222528"}
                        type="text"
                        name="flat_suite"
                        lableText={t("AddProperties.flatSuiteUnit")}
                        placeholderText={t("AddProperties.enterFlatSuiteUnit")}
                        onChange={(e) => setFieldValue("flat_suite", e.target.value)}
                        value={values.flat_suite}
                    />
                    {submitted && errors.flat_suite && (
                        <ErrorMessage
                            name="flat_suite"
                            component="div"
                            className="errorStyle mb-3"
                        />
                    )}
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Zone</Form.Label>
                        <Field
                            as="select"
                            name="zone_id"
                            className="form-select"
                            value={values.zone_id}
                            placeholderText={t("AddProperties.selectZone")}
                            onChange={(e) => {
                                setFieldValue("zone_id", e.target.value);
                                setFieldValue("city_id", "");
                                setselectedzone(e.target.value);
                            }}
                        >
                            <option value="">{t("AddProperties.selectZone")}</option>
                            {zones.map((zone_id) => (
                                <option key={zone_id.id} value={zone_id.id}>
                                    {zone_id.zone_name}
                                </option>
                            ))}
                        </Field>
                        {submitted && errors.zone_id && (
                            <ErrorMessage
                                name="zone_id"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("AddProperties.city")}</Form.Label>
                        <Field
                            as="select"
                            name="city_id"
                            className="form-select"
                            value={values.city_id}
                        >
                            <option value="">{t("AddProperties.selectCity")}</option>
                            {cities?.map((city_id) => (
                                <option key={city_id.id} value={city_id.id}>
                                    {city_id.city_name}
                                </option>
                            ))}
                        </Field>
                        {submitted && errors.city_id && (
                            <ErrorMessage
                                name="city_id"
                                component="div"
                                className="errorStyle"
                            />
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
};

export default Step1Address;
